import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import {
  Container,
  Grid,
  Typography,
  makeStyles,
  Box,
  Avatar,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingTop: 48,
    paddingBottom: 48,
  },
  valueContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  item: {
    padding: theme.spacing(3),
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      '&:not(:last-of-type)': {
        borderRight: `1px solid ${theme.palette.divider}`
      }
    },
    [theme.breakpoints.down('sm')]: {
      '&:not(:last-of-type)': {
        borderBottom: `1px solid ${theme.palette.divider}`
      }
    }
  },
  icon: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.background.contrastText,
    height: 120,
    width: 120,
  },
}));

const Recommendation = ({ className, ...rest }) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <Container maxWidth="lg">
        <Box mt={8}>
          <Grid container spacing={3} >
            <Grid item xs={12} md={4}  className={classes.item}>
              <Box
                display="flex"
                alignItems="center"
                flexDirection="column"
                justifyContent="center"
              >
                <Avatar className={classes.icon}>
                <Typography variant="h2">320K</Typography>
                </Avatar>
                <Typography variant="h3" gutterBottom color="textPrimary">
                  QR Codes Downloded
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}  className={classes.item}>
              <Box
                display="flex"
                alignItems="center"
                flexDirection="column"
                justifyContent="center"
              >
                <Avatar className={classes.icon}>
                  <Typography variant="h2">31K</Typography>
                </Avatar>
                <Typography variant="h3" gutterBottom color="textPrimary">
                  Active Users
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}  className={classes.item}>
              <Box
                display="flex"
                alignItems="center"
                flexDirection="column"
                justifyContent="center"
              >
                <Avatar className={classes.icon}>
                <Typography variant="h2">920K</Typography>            
                </Avatar>
                <Typography variant="h3" gutterBottom color="textPrimary">
                  QR Codes Scanned
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </div>
  );
};

Recommendation.propTypes = {
  className: PropTypes.string,
};

export default Recommendation;
